import { Grid, Tooltip} from "@mui/material";

export function getPartyStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        title:{
            name:'title',
            label:'Title',
            value:'',
            error:false,
            errorMessage:'You must enter Title',
            required:true,
            fieldtype:'string'
        },
        address:{
            name:'address',
            label:'Address',
            value:'',
            error:false,
            errorMessage:'You must enter Address',
            required:true,
            fieldtype:'string'
        },
        dispatchaddress:{
            name:'dispatchaddress',
            label:'Dispatch Address',
            value:'',
            error:false,
            errorMessage:'You must enter Dispatch Address',
            required:true,
            fieldtype:'string'
        },
        sameaddress:{
            name:'sameaddress',
            label:'Same Address',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'boolean'
        },
        ordervalue:{
            name:'ordervalue',
            label:'Order Value',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'double'
        },
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'You must enter Business Id',
            required:true,
            fieldtype:'ID'
        },
        corporateemail:{
            name:'corporateemail',
            label:'Corporate Email',
            value:'',
            error:false,
            errorMessage:'You must enter Corporate Email',
            required:true,
            fieldtype:'emailid'
        },
        contact:{
            name:'contact',
            label:'Contact',
            value:'',
            error:false,
            errorMessage:'You must enter Contact',
            required:true,
            fieldtype:'string'
        },
        contactmobile:{
            name:'contactmobile',
            label:'Contact Mobile',
            value:'',
            error:false,
            errorMessage:'You must enter Contact Mobile',
            required:true,
            fieldtype:'mobile'
        },
        druglicense:{
            name:'druglicense',
            label:'Drug License',
            value:'',
            error:false,
            errorMessage:'You must enter Drug License',
            required:true,
            fieldtype:'string'
        },
        gst:{
            name:'gst',
            label:'GST',
            value:'',
            error:false,
            errorMessage:'You must enter GST',
            required:true,
            fieldtype:'string'
        },
        statusid:{
            name:'statusid',
            label:'Status Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'bodynamiclist'
        },
        statusname:{
            name:'statusname',
            label:'Status Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        status:{
            name:'status',
            label:'Status',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'boolean'
        },
        rejectionreason:{
            name:'rejectionreason',
            label:'Rejection Reason',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'title', headerName: 'Title', width:150 },
        { field: 'contact', headerName: 'Contact', width:150 },
        { field: 'contactmobile', headerName: 'Contact Mobile', width:150 },
        { field: 'druglicense', headerName: 'Drug License', width:150 },
        { field: 'gst', headerName: 'GST', width:150 },
        { field: 'statusname', headerName: 'Status Name', width:150 },
        { field: 'status', headerName: 'Status', width:150 },
        { field: 'rejectionreason', headerName: 'Rejection Reason', width:150 },
        { field: 'address', headerName: 'Address', width:250 },
        { field: 'corporateemail', headerName: 'Corporate Email', width:200 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['title']:{
          ...formValues['title'],
          value:data.title,
        },['contact']:{
          ...formValues['contact'],
          value:data.contact,
        },['contactmobile']:{
          ...formValues['contactmobile'],
          value:data.contactmobile,
        },['druglicense']:{
          ...formValues['druglicense'],
          value:data.druglicense,
        },['gst']:{
          ...formValues['gst'],
          value:data.gst,
        },['statusid']:{
          ...formValues['statusid'],
          value:data.statusid,
        },['statusname']:{
          ...formValues['statusname'],
          value:data.statusname,
        },['status']:{
          ...formValues['status'],
          value:data.status,
        },['rejectionreason']:{
          ...formValues['rejectionreason'],
          value:data.rejectionreason,
        },['ordervalue']:{
          ...formValues['ordervalue'],
          value:data.ordervalue,
        },['address']:{
          ...formValues['address'],
          value:data.address,
        },['dispatchaddress']:{
          ...formValues['dispatchaddress'],
          value:data.dispatchaddress,
        },['sameaddress']:{
          ...formValues['sameaddress'],
          value:data.sameaddress,
        },['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['corporateemail']:{
          ...formValues['corporateemail'],
          value:data.corporateemail,
        },
      })
}